// extracted by mini-css-extract-plugin
module.exports = {"descriptionMask":"Coupon_descriptionMask__13pUD","couponLink":"Coupon_couponLink___nvQP","couponBottom":"Coupon_couponBottom__bcjKW"};